import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=b4ca7c60&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"
import style0 from "./issue.vue?vue&type=style&index=0&id=b4ca7c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ca7c60",
  null
  
)

export default component.exports